import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import API_URL from "../../src/Config";
import { FaPlusCircle } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import Select from "react-select";
import { MdAttachFile } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import { FiUpload } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";
import { useContext } from "react";
import { ThemeContext } from "../../src/ThemeContext";
function EditVendor({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [vendorData, setVendorData] = useState({
    vendor_name: "",
    vendor_type: "",
    locations: [
      {
        location: "",
        contact_person_name: "",
        contact_no: "",
        location_email: "",
        location_address: "",
      },
    ],
    address: "",
    contact_no: "",
    gst_no: "",
    pan_no: "",
    is_msme: "",
  });
  const { theme } = useContext(ThemeContext);
  const [error, setError] = useState({});
  const [severity, setSeverity] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [msmeChecked, setMsmeChecked] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isIncorporationPopupOpen, setIsIncorporationPopupOpen] =
    useState(false);
  const [isGSTPopupOpen, setIsGSTPopupOpen] = useState(false);
  const [isPANPopupOpen, setIsPANPopupOpen] = useState(false);
  const [isMSMEPopupOpen, setIsMSMEPopupOpen] = useState(false);
  const fileInputRef = useRef(null);
  const [selectedGSTFiles, setSelectedGSTFiles] = useState([]);
  const [selectedPANFiles, setSelectedPANFiles] = useState([]);
  const [selectedMSMEFiles, setSelectedMSMEFiles] = useState([]);
  const gstFileInputRef = useRef(null);
  const panFileInputRef = useRef(null);
  const incorporationFileInputRef = useRef(null);
  const msmeFileInputRef = useRef(null);
  const [selectedIncorporationFiles, setSelectedIncorporationFiles] = useState(
    []
  );

  useEffect(() => {
    const fetchVendorData = async () => {
      try {
        const authKey = localStorage.getItem("authKey");
        const response = await axios.get(`${API_URL}/api/get_vendor/${id}`, {
          headers: {
            Authorization: authKey,
          },
        });
        const responseData = response.data;
        setVendorData({
          vendor_name: responseData.vendor_name,
          vendor_type: responseData.vendor_type,
          locations: responseData.locations.map((location) => ({
            location: location.location,
            contact_person_name: location.contact_person_name,
            location_contact_no: location.contact_no,
            location_email: location.email,
            location_address: location.address,
          })),
          address: responseData.address,
          contact_no: responseData.contact_no,
          gst_no: responseData.gst_no,
          pan: responseData.pan,
        });
        setMsmeChecked(responseData.is_msme === 1);
      } catch (error) {
        console.error("Error fetching vendor data:", error.message);
        setError({ general: "An error occurred while fetching vendor data" });
      }
    };

    fetchVendorData();
  }, [id]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSaveClick();
    }
  };
  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };
  const validateContactNumber = (contactNo) => {
    const contactPattern = /^\d{10}$/;
    return contactPattern.test(contactNo);
  };

  const handleFileInputChange = (files, setFiles) => {
    const fileArray = Array.from(files);
    setFiles(fileArray);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Update vendorData state with the new value
    setVendorData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear the error message for the specific field being updated
    setError((prevState) => ({
      ...prevState,
      [name]: "",
    }));
    setError((prevState) => ({
      ...prevState,
      locations: "",
    }));
  };

  const handleLocationChange = (e, index, field) => {
    const { value } = e.target;
    const updatedLocations = vendorData.locations.map((location, i) =>
      i === index ? { ...location, [field]: value } : location
    );
    setVendorData({ ...vendorData, locations: updatedLocations });
  };

  const handleCancelClick = () => {
    // navigate("/vendors");
    window.history.back();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  // const handleSaveClick = async () => {
  //   const errors = {};
  //   let error = false;

  //   // Validate required fields
  //   if (!vendorData.vendor_name.trim()) {
  //     errors.vendor_name = "Vendor name is required";
  //     error = true;
  //   }
  //   if (!vendorData.vendor_type.trim()) {
  //     errors.vendor_type = "Vendor type is required";
  //     error = true;
  //   }
  //   if (!vendorData.contact_no.trim()) {
  //     errors.contact_no = "Contact number is required";
  //     error = true;
  //   }
  //   if (!vendorData.address.trim()) {
  //     errors.address = "Address is required";
  //     error = true;
  //   }

  //   setError(errors);

  //   if (!error) {
  //     try {
  //       setIsLoading(true);
  //       const authKey = localStorage.getItem("authKey");
  //       const response = await axios.put(
  //         `${API_URL}/api/update_vendor/${id}`,
  //         vendorData,
  //         {
  //           headers: {
  //             Authorization: authKey,
  //           },
  //         }
  //       );
  //       console.log(response.data.message);
  //       if (response.status === 200) {
  //         setSeverity("success");
  //         showSnackbar("Data updated successfully");
  //         setTimeout(() => {
  //           navigate("/vendors");
  //         }, 1000);
  //       }
  //     } catch (error) {
  //       console.error("Error updating vendor:", error.message);
  //       setError({ general: "An error occurred while updating vendor data" });
  //       setIsLoading(false);
  //     }
  //   } else {
  //     setSeverity("warning");
  //     showSnackbar("Required fields are empty");
  //   }
  // };
  const handleDeleteMsmeFile = (indexToDelete) => {
    console.log("Delete function called for index:", indexToDelete);
    console.log("Before delete:", selectedPANFiles);

    // Filter out the file at the given index
    const updatedFiles = selectedMSMEFiles.filter(
      (_, index) => index !== indexToDelete
    );

    // Update the state
    setSelectedMSMEFiles(updatedFiles);
    console.log("After delete:", updatedFiles);

    // Check if no files remain, then close the popup
    if (updatedFiles.length === 0) {
      handleMSMECloseAttachment(); // Close the popup if no files remain
      console.log("Popup closed");
    }
  };
  const handleSaveClick = async () => {
    const newErrors = {};
    let error = false;

    const validateExactTenDigits = (number) => /^\d{10}$/.test(number);

    // Validate required fields for vendor data
    if (!vendorData.vendor_name.trim()) {
      newErrors.vendor_name = "Vendor name is required";
      error = true;
    }
    if (!vendorData.vendor_type.trim()) {
      newErrors.vendor_type = "Vendor type is required";
      error = true;
    }
    // if (!vendorData.contact_no.trim()) {
    //   newErrors.contact_no = "Contact number is required";
    //   error = true;
    // }

    if (!vendorData.contact_no.trim()) {
      newErrors.contact_no = "Contact number is required";
      error = true;
    } else if (vendorData.contact_no.length > 10) {
      newErrors.contact_no = "Enter only 10 digits";
      error = true;
    } else if (!validateExactTenDigits(vendorData.contact_no)) {
      newErrors.contact_no = "Contact number must contain exactly 10 digits";
      error = true;
    }
    if (!vendorData.address.trim()) {
      newErrors.address = "Address is required";
      error = true;
    }

    // Validate each location's required fields and formats
    vendorData.locations.forEach((location, index) => {
      const locationErrors = {};

      // Check for empty fields
      if (!location.location.trim()) {
        locationErrors.location = "Location is required";
        error = true;
      }
      if (!location.contact_person_name.trim()) {
        locationErrors.contact_person_name = "Contact person name is required";
        error = true;
      }
      if (!location.location_contact_no.trim()) {
        locationErrors.location_contact_no = "Contact number is required";
        error = true;
      } else if (!validateContactNumber(location.location_contact_no)) {
        locationErrors.location_contact_no = "Invalid contact number";
        error = true;
      }
      if (!location.location_email.trim()) {
        locationErrors.location_email = "Email is required";
        error = true;
      } else if (!validateEmail(location.location_email)) {
        locationErrors.location_email = "Invalid email format";
        error = true;
      }
      if (!location.location_address.trim()) {
        locationErrors.location_address = "Address is required";
        error = true;
      }

      // Assign location-specific errors to the main error object if there are any
      if (Object.keys(locationErrors).length > 0) {
        newErrors[`location_${index}`] = locationErrors;
      }
    });

    // If no locations provided
    if (vendorData.locations.length === 0) {
      newErrors.locations = "At least one location is required";
      error = true;
    }

    if (error) {
      setError(newErrors);
      setSeverity("warning");
      showSnackbar("Please fix the validation errors.");
      return; // Prevent further execution if there are validation errors
    }

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      // Create a new FormData object
      const formData = new FormData();

      // Append vendor data fields individually
      formData.append("vendor_name", vendorData.vendor_name);
      formData.append("vendor_type", vendorData.vendor_type);
      formData.append("contact_no", vendorData.contact_no);
      formData.append("address", vendorData.address);
      formData.append("pan", vendorData.pan);
      formData.append("gst_no", vendorData.gst_no);
      formData.append("is_msme", msmeChecked ? "1" : "0");
      formData.append("locations", JSON.stringify(vendorData.locations));

      // Append each file with respective key
      // selectedGSTFiles.forEach((file) => formData.append("gst_attachments", file));
      // selectedPANFiles.forEach((file) => formData.append("pan_attachments", file));
      // selectedIncorporationFiles.forEach((file) => formData.append("incorporation_attachments", file));
      // selectedMSMEFiles.forEach((file) => formData.append("msme_attachments", file));

      selectedGSTFiles.forEach((file) =>
        formData.append("gst_attachments", file)
      );
      selectedPANFiles.forEach((file) =>
        formData.append("pan_attachments", file)
      );
      selectedGSTFiles.forEach((fileData, type) =>
        formData.append("gst_file_types", "gst")
      );
      selectedPANFiles.forEach((fileData, type) =>
        formData.append("pan_file_types", "pan")
      );
      selectedIncorporationFiles.forEach((fileData, type) =>
        formData.append("incorporation_file_types", "incorporation")
      );
      selectedMSMEFiles.forEach((fileData, type) =>
        formData.append("msme_file_types", "msme")
      );
      selectedIncorporationFiles.forEach((file) =>
        formData.append("incorporation_attachments", file)
      );
      selectedMSMEFiles.forEach((file) =>
        formData.append("msme_attachments", file)
      );

      // Make POST request
      const response = await axios.put(
        `${API_URL}/api/update_vendor/${id}`,
        formData,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Vendor added successfully");
        setTimeout(() => {
          navigate("/vendors");
        }, 1000);
      } else {
        setSeverity("error");
        showSnackbar("Failed to add vendor");
      }
    } catch (error) {
      console.error("Error saving vendor:", error.message);
      setSeverity("error");
      showSnackbar("Error saving vendor");
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackProject = () => {
    navigate("/vendors");
  };

  const handleAddLocation = () => {
    setVendorData((prevState) => ({
      ...prevState,
      locations: [
        ...prevState.locations,
        {
          location: "",
          contact_person_name: "",
          location_contact_no: "",
          location_email: "",
          location_address: "",
        },
      ],
    }));
  };

  const handleUploadButtonClick = (fileInputRef) => {
    fileInputRef.current.click();
  };
  const handleGSTCloseAttachment = () => {
    setIsGSTPopupOpen(false);
  };
  const handlePANCloseAttachment = () => {
    setIsPANPopupOpen(false);
  };
  const handleMSMECloseAttachment = () => {
    setIsMSMEPopupOpen(false);
  };
  const handleIncorporationCloseAttachment = () => {
    setIsIncorporationPopupOpen(false);
  };
  const handleDeletePanFile = (indexToDelete) => {
    console.log("Delete function called for index:", indexToDelete);
    console.log("Before delete:", selectedPANFiles);

    // Filter out the file at the given index
    const updatedFiles = selectedPANFiles.filter(
      (_, index) => index !== indexToDelete
    );

    // Update the state
    setSelectedPANFiles(updatedFiles);
    console.log("After delete:", updatedFiles);

    // Check if no files remain, then close the popup
    if (updatedFiles.length === 0) {
      handlePANCloseAttachment(); // Close the popup if no files remain
      console.log("Popup closed");
    }
  };
  const handleDeleteFile = (indexToDelete) => {
    console.log("Delete function called for index:", indexToDelete);
    console.log("Before delete:", selectedGSTFiles);

    // Filter out the file at the given index
    const updatedFiles = selectedGSTFiles.filter(
      (_, index) => index !== indexToDelete
    );

    // Update the state
    setSelectedGSTFiles(updatedFiles);
    console.log("After delete:", updatedFiles);

    // Check if no files remain, then close the popup
    if (updatedFiles.length === 0) {
      handleGSTCloseAttachment(); // Close the popup if no files remain
      console.log("Popup closed");
    }
  };
  const handleIncorporationIconClick = () => {
    // Show selected files when icon is clicked
    setIsIncorporationPopupOpen(true);
    setIsGSTPopupOpen(false);
    setIsPANPopupOpen(false);
    setIsMSMEPopupOpen(false);
  };
  const handleGSTIconClick = () => {
    // Show selected files when icon is clicked
    setIsGSTPopupOpen(true);
    setIsIncorporationPopupOpen(false);
    setIsPANPopupOpen(false);
    setIsMSMEPopupOpen(false);
  };
  const handlePANIconClick = () => {
    // Show selected files when icon is clicked
    setIsPANPopupOpen(true);
    setIsGSTPopupOpen(false);
    setIsIncorporationPopupOpen(false);
    setIsMSMEPopupOpen(false);
  };
  const handleMSMEIconClick = () => {
    // Show selected files when icon is clicked
    setIsMSMEPopupOpen(true);
    setIsGSTPopupOpen(false);
    setIsIncorporationPopupOpen(false);
    setIsPANPopupOpen(false);
  };
  const handleCheckboxChange = (e) => {
    setMsmeChecked(e.target.checked);
  };
  const handleRemoveLocation = (index) => {
    const newLocations = vendorData.locations.filter((_, i) => i !== index);
    setVendorData((prevState) => ({
      ...prevState,
      locations: newLocations,
    }));
  };
  const handleDeleteincorporationFile = (indexToDelete) => {
    console.log("Delete function called for index:", indexToDelete);
    console.log("Before delete:", selectedIncorporationFiles);

    // Filter out the file at the given index
    const updatedFiles = selectedIncorporationFiles.filter(
      (_, index) => index !== indexToDelete
    );

    // Update the state using the setter function
    setSelectedIncorporationFiles(updatedFiles); // Ensure you're using the correct setter function

    console.log("After delete:", updatedFiles);

    // Check if no files remain, then close the popup
    if (updatedFiles.length === 0) {
      handleIncorporationCloseAttachment(); // Close the popup if no files remain
      console.log("Popup closed");
    }
  };
  const handleVendorTypeChange = (selectedOption) => {
    setVendorData((prevState) => ({
      ...prevState,
      vendor_type: selectedOption.value,
    }));
    setError({ ...error, vendor_type: "" }); // Clear validation error when input changes
  };

  const options = [
    { value: "Service", label: "Service" },
    { value: "Material", label: "Material" },
    { value: "Both", label: "Both" },
  ];

  return (
    <>
      <div
        className={`data-edit-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-edit-form-content">
          <div className="data-edit-form-header">
            <div className="data-edit-form-header-content">
              <div className="data-edit-form-heading-content-left-side">
                <Tooltip title="Back" arrow>
                  <IoMdArrowBack
                    className="back-company"
                    onClick={handleBackProject}
                  />
                </Tooltip>
                Edit Vendor
              </div>
              <div className="data-edit-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-edit-form-body">
            <form className="form-detail" onKeyDown={handleKeyDown}>
              <div className="new-data-form">
                <div className="form-group">
                  <label htmlFor="vendor_name">
                    Vendor Name<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="vendor_name"
                      value={vendorData.vendor_name}
                      onChange={handleInputChange}
                      placeholder="Enter vendor name"
                    />
                  </div>
                  {error.vendor_name && (
                    <div className="error-message">{error.vendor_name}</div>
                  )}
                </div>
                <div className="form-group-select">
                  <label htmlFor="vendor_type">
                    Type of Vendor<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="vendor_type"
                    options={options}
                    value={options.find(
                      (option) => option.value === vendorData.vendor_type
                    )}
                    onChange={handleVendorTypeChange}
                    placeholder="Select vendor type..."
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "black" : "white", // Dropdown background color
                        color: theme === "dark" ? "#fff" : "#333", // Text color
                        borderColor: theme === "dark" ? "#444" : "#ccc", // Border color for control
                        cursor: "pointer",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: theme === "dark" ? "#666" : "#888", // Border color on hover
                        },
                      }),
                      menu: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
                        border: `1px solid ${
                          theme === "dark" ? "#444" : "#ccc"
                        }`, // Border for the menu
                        borderRadius: "4px", // Optional: add border radius for rounded edges
                        zIndex: 999, // Ensures the menu appears above other elements
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused
                          ? "#666" // Gray when hovered
                          : theme === "dark"
                          ? "#000"
                          : "#fff", // Black background for options in dark mode
                        color: state.isFocused
                          ? "#fff"
                          : theme === "dark"
                          ? "#fff"
                          : "#333", // Text color
                        cursor: "pointer",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: theme === "dark" ? "#fff" : "#333", // Selected option text color
                      }),
                    }}
                  />
                  {error.vendor_type && (
                    <div className="error-message">{error.vendor_type}</div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="contact_no">
                    Contact No<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="number"
                      name="contact_no"
                      value={vendorData.contact_no}
                      onChange={handleInputChange}
                      placeholder="Enter contact no"
                    />
                  </div>
                  {error.contact_no && (
                    <div className="error-message">{error.contact_no}</div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="gst_no">GST No</label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="gst_no"
                      value={vendorData.gst_no}
                      onChange={handleInputChange}
                      placeholder="Enter GST no"
                    />
                  </div>
                </div>
                <div className="form-group-attachments">
                  <div className="form-group">
                    <label htmlFor="gst_attachments">GST Certificate</label>
                    <button
                      type="button"
                      className="challan-btn"
                      onClick={() => handleUploadButtonClick(gstFileInputRef)}
                    >
                      <FiUpload /> Upload File
                    </button>
                    <input
                      type="file"
                      id="gst_attachments"
                      ref={gstFileInputRef}
                      onChange={(e) =>
                        handleFileInputChange(
                          e.target.files,
                          setSelectedGSTFiles
                        )
                      }
                      style={{ display: "none" }}
                      multiple
                    />
                    {selectedGSTFiles.length > 0 && (
                      <span
                        className="inquiry-file-btn"
                        onClick={handleGSTIconClick}
                      >
                        <MdAttachFile className="inquiry-file-icon" />{" "}
                        {`${selectedGSTFiles.length}`}
                      </span>
                    )}
                    {isGSTPopupOpen && (
                      <div className="attach-popup-amc1">
                        <div className="attach-popup-contant">
                          <div className="attachment-header">
                            <div className="attachment-header-content">
                              Attachments
                            </div>
                            <button
                              className="fiile-close-btn"
                              onClick={handleGSTCloseAttachment}
                            >
                              <IoCloseOutline className="file-close-icon" />
                            </button>
                          </div>
                          {selectedGSTFiles.length > 0 && (
                            <div className="attach-scrroll-body">
                              {selectedGSTFiles.map((file, index) => (
                                <div
                                  className="attach-popup-contant-body"
                                  key={index}
                                >
                                  <div className="attach-file-container">
                                    <div className="attach-file-show">
                                      <div className="text-attachment">
                                        {file.name}
                                      </div>
                                      <div className="text-attachment-file">
                                        File Size:(
                                        {(file.size / 1024).toFixed(2)} KB)
                                      </div>
                                    </div>
                                    <div
                                      className="file-delete-btn"
                                      onClick={() => handleDeleteFile(index)}
                                    >
                                      <span>
                                        {" "}
                                        <MdDeleteOutline className="file-delete-icon" />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="pan">PAN No</label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="pan"
                      value={vendorData.pan}
                      onChange={handleInputChange}
                      placeholder="Enter PAN no"
                    />
                  </div>
                  {error.pan && (
                    <div className="error-message">{error.pan}</div>
                  )}
                </div>
                <div className="form-group-attachments">
                  <div className="form-group">
                    <label htmlFor="pan_attachments">
                      PAN Copy Certificate
                    </label>
                    <button
                      type="button"
                      className="challan-btn"
                      onClick={() => handleUploadButtonClick(panFileInputRef)}
                    >
                      <FiUpload /> Upload File
                    </button>
                    <input
                      id="pan_attachments"
                      type="file"
                      ref={panFileInputRef}
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleFileInputChange(
                          e.target.files,
                          setSelectedPANFiles
                        )
                      }
                      multiple
                    />
                    {selectedPANFiles.length > 0 && (
                      <span
                        className="inquiry-file-btn"
                        onClick={handlePANIconClick}
                      >
                        <MdAttachFile className="inquiry-file-icon" />{" "}
                        {`${selectedPANFiles.length}`}
                      </span>
                    )}
                    {isPANPopupOpen && (
                      <div className="attach-popup-amc2">
                        <div className="attach-popup-contant">
                          <div className="attachment-header">
                            <div className="attachment-header-content">
                              Attachments
                            </div>
                            <button
                              className="fiile-close-btn"
                              onClick={handlePANCloseAttachment}
                            >
                              <IoCloseOutline className="file-close-icon" />
                            </button>
                          </div>
                          {selectedPANFiles.length > 0 && (
                            <div className="attach-scrroll-body">
                              {selectedPANFiles.map((file, index) => (
                                <div
                                  className="attach-popup-contant-body"
                                  key={index}
                                >
                                  <div className="attach-file-container">
                                    <div className="attach-file-show">
                                      <div className="text-attachment">
                                        {file.name}
                                      </div>
                                      <div className="text-attachment-file">
                                        File Size:(
                                        {(file.size / 1024).toFixed(2)} KB)
                                      </div>
                                    </div>
                                    <div
                                      className="file-delete-btn"
                                      onClick={() => handleDeletePanFile(index)}
                                    >
                                      <span>
                                        {" "}
                                        <MdDeleteOutline className="file-delete-icon" />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-group-attachments">
                  <div className="form-group">
                    <label htmlFor="incorporation_attachments">
                      Incorporation Certificate
                    </label>
                    <button
                      type="button"
                      className="challan-btn"
                      onClick={() =>
                        handleUploadButtonClick(incorporationFileInputRef)
                      }
                    >
                      <FiUpload /> Upload File
                    </button>
                    <input
                      id="incorporation_attachments"
                      type="file"
                      ref={incorporationFileInputRef}
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleFileInputChange(
                          e.target.files,
                          setSelectedIncorporationFiles
                        )
                      }
                      multiple
                    />
                    {selectedIncorporationFiles.length > 0 && (
                      <span
                        className="inquiry-file-btn"
                        onClick={handleIncorporationIconClick}
                      >
                        <MdAttachFile className="inquiry-file-icon" />{" "}
                        {`${selectedIncorporationFiles.length}`}
                      </span>
                    )}
                    {isIncorporationPopupOpen && (
                      <div className="attach-popup-amc3 vendor-third-popup">
                        <div className="attach-popup-contant">
                          <div className="attachment-header">
                            <div className="attachment-header-content">
                              Attachments
                            </div>
                            <button
                              className="fiile-close-btn"
                              onClick={handleIncorporationCloseAttachment}
                            >
                              <IoCloseOutline className="file-close-icon" />
                            </button>
                          </div>
                          {selectedIncorporationFiles.length > 0 && (
                            <div className="attach-scrroll-body">
                              {selectedIncorporationFiles.map((file, index) => (
                                <div
                                  className="attach-popup-contant-body"
                                  key={index}
                                >
                                  <div className="attach-file-container">
                                    <div className="attach-file-show">
                                      <div className="text-attachment">
                                        {file.name}
                                      </div>
                                      <div className="text-attachment-file">
                                        File Size:(
                                        {(file.size / 1024).toFixed(2)} KB)
                                      </div>
                                    </div>
                                    <div
                                      className="file-delete-btn"
                                      onClick={() =>
                                        handleDeleteincorporationFile(index)
                                      }
                                    >
                                      <span>
                                        {" "}
                                        <MdDeleteOutline className="file-delete-icon" />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="address">
                    Address<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="address"
                      value={vendorData.address}
                      onChange={handleInputChange}
                      placeholder="Enter address"
                    />
                  </div>
                  {error.address && (
                    <div className="error-message">{error.address}</div>
                  )}
                </div>
                <div className="form-group msmme">
                  <label htmlFor="is_msme">
                    Is MSME ?<span className="text-danger">*</span>
                  </label>

                  <div className="checkbox-input">
                    <input
                      type="checkbox"
                      id="msme_yes"
                      name="is_msme"
                      value="yes"
                      checked={msmeChecked}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="msmeYes">Yes</label>
                  </div>
                  <div className="checkbox-input">
                    <input
                      type="checkbox"
                      id="msme_no"
                      name="is_msme"
                      value="no"
                      checked={!msmeChecked}
                      onChange={() => setMsmeChecked(false)}
                    />
                    <label htmlFor="msmeNo">No</label>
                  </div>
                </div>
                <div className="form-group-attachments">
                  {msmeChecked && (
                    <div className="form-group">
                      <label htmlFor="msme_attachments">MSME Certificate</label>
                      <button
                        type="button"
                        className="challan-btn"
                        onClick={() =>
                          handleUploadButtonClick(msmeFileInputRef)
                        }
                      >
                        <FiUpload /> Upload File
                      </button>
                      <input
                        id="msme_attachments"
                        type="file"
                        ref={msmeFileInputRef}
                        style={{ display: "none" }}
                        onChange={(e) =>
                          handleFileInputChange(
                            e.target.files,
                            setSelectedMSMEFiles
                          )
                        }
                        multiple
                      />
                      {selectedMSMEFiles.length > 0 && (
                        <span
                          className="inquiry-file-btn"
                          onClick={handleMSMEIconClick}
                        >
                          <MdAttachFile className="inquiry-file-icon" />{" "}
                          {`${selectedMSMEFiles.length}`}
                        </span>
                      )}
                      {isMSMEPopupOpen && (
                        <div className="attach-popup-amc">
                          <div className="attach-popup-contant">
                            <div className="attachment-header">
                              <div className="attachment-header-content">
                                Attachments
                              </div>
                              <button
                                className="fiile-close-btn"
                                onClick={handleMSMECloseAttachment}
                              >
                                <IoCloseOutline className="file-close-icon" />
                              </button>
                            </div>
                            {selectedMSMEFiles.length > 0 && (
                              <div className="attach-scrroll-body">
                                {selectedMSMEFiles.map((file, index) => (
                                  <div
                                    className="attach-popup-contant-body"
                                    key={index}
                                  >
                                    <div className="attach-file-container">
                                      <div className="attach-file-show">
                                        <div className="text-attachment">
                                          {file.name}
                                        </div>
                                        <div className="text-attachment-file">
                                          File Size:(
                                          {(file.size / 1024).toFixed(2)} KB)
                                        </div>
                                      </div>
                                      <div
                                        className="file-delete-btn"
                                        onClick={() =>
                                          handleDeleteMsmeFile(index)
                                        }
                                      >
                                        <span>
                                          {" "}
                                          <MdDeleteOutline className="file-delete-icon" />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Place of Business<span className="text-danger">*</span>
                  </label>
                  <div className="new-frequency-rowss">
                    {vendorData.locations.map((location, index) => (
                      <div key={index} className="location-group-content">
                        <div className="location-group">
                          <div className="input-group frequency-row">
                            <textarea
                              className="point-fr"
                              name={`Location_${index}`}
                              value={location.location}
                              onChange={(e) =>
                                handleLocationChange(e, index, "location")
                              }
                              placeholder={`Enter place of business ${
                                index + 1
                              }`}
                              cols="30"
                              rows="2"
                            ></textarea>
                            {/* {error[`location_${index}`]?.location && (
                              <div className="error-message">{error[`location_${index}`].location}</div>
                            )} */}
                          </div>
                          {error[`location_${index}`]?.location && (
                            <div className="error-message">
                              {error[`location_${index}`].location}
                            </div>
                          )}
                          <div className="flex-group">
                            <div>
                              <div className="input-group frequency-row">
                                <input
                                  type="text"
                                  className="point-fr"
                                  name={`ContactPersonName_${index}`}
                                  value={location.contact_person_name}
                                  onChange={(e) =>
                                    handleLocationChange(
                                      e,
                                      index,
                                      "contact_person_name"
                                    )
                                  }
                                  placeholder="Enter contact person name"
                                />
                                {/* {error[`location_${index}`]?.contact_person_name && (
                                  <div className="error-message">{error[`location_${index}`].contact_person_name}</div>
                                )} */}
                              </div>
                              {error[`location_${index}`]
                                ?.contact_person_name && (
                                <div className="error-message">
                                  {
                                    error[`location_${index}`]
                                      .contact_person_name
                                  }
                                </div>
                              )}
                              <div className="input-group frequency-row">
                                <input
                                  type="number"
                                  className="point-fr"
                                  name={`LocationContactNo_${index}`}
                                  value={location.location_contact_no}
                                  onChange={(e) =>
                                    handleLocationChange(
                                      e,
                                      index,
                                      "location_contact_no"
                                    )
                                  }
                                  placeholder="Enter location contact no"
                                />
                                {/* {error[`location_${index}`]?.location_contact_no && (
                                  <div className="error-message">{error[`location_${index}`].location_contact_no}</div>
                                )} */}
                              </div>
                              {error[`location_${index}`]
                                ?.location_contact_no && (
                                <div className="error-message">
                                  {
                                    error[`location_${index}`]
                                      .location_contact_no
                                  }
                                </div>
                              )}
                              <div className="input-group frequency-row">
                                <input
                                  type="email"
                                  className="point-fr"
                                  name={`LocationEmail_${index}`}
                                  value={location.location_email}
                                  onChange={(e) =>
                                    handleLocationChange(
                                      e,
                                      index,
                                      "location_email"
                                    )
                                  }
                                  placeholder="Enter location email"
                                />
                                {/* {error[`location_${index}`]?.location_email && (
                                  <div className="error-message">{error[`location_${index}`].location_email}</div>
                                )} */}
                              </div>
                              {error[`location_${index}`]?.location_email && (
                                <div className="error-message">
                                  {error[`location_${index}`].location_email}
                                </div>
                              )}
                            </div>
                            <div>
                              <div className="input-group frequency-row">
                                <textarea
                                  className="point-fr"
                                  name={`LocationAddress_${index}`}
                                  value={location.location_address}
                                  onChange={(e) =>
                                    handleLocationChange(
                                      e,
                                      index,
                                      "location_address"
                                    )
                                  }
                                  placeholder="Enter location address"
                                  cols="30"
                                  rows="6.9"
                                ></textarea>
                                {/* {error[`location_${index}`]?.location_address && (
                                  <div className="error-message">{error[`location_${index}`].location_address}</div>
                                )} */}
                              </div>
                              {error[`location_${index}`]?.location_address && (
                                <div className="error-message">
                                  {error[`location_${index}`].location_address}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="add-close-button"
                            onClick={() => handleRemoveLocation(index)}
                            disabled={vendorData.locations.length === 1}
                          >
                            <IoClose className="frequency-close-icon" />
                          </button>
                        </div>
                      </div>
                    ))}

                    <div className="add-new-frequency-customer">
                      <button
                        className="add-new-buttons"
                        type="button"
                        onClick={handleAddLocation}
                      >
                        <FaPlusCircle className="frequency-plus-icon" />
                      </button>
                    </div>
                  </div>
                  {/* {error.locations && (
                    <div className="error-message">{error.locations}</div>
                  )} */}
                </div>
                {error.locations && (
                  <div className="error-message">{error.locations}</div>
                )}
              </div>
            </form>
          </div>
          <div className="footer">
            <div className="button-group">
              <button
                className="data-edit-form-save-button"
                type="save"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="data-edit-form-cancel-button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ transform: "translateY(40px)", marginLeft: "15px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default EditVendor;
